/**
 * Root query-key factory (contract §7.6).
 *
 * Shape is `[domain, kind, ...args]` so `invalidateQueries({queryKey: qk.members.all()})`
 * sweeps a whole domain. The active branch is part of every list key — see
 * `useBranchScopedParams()`; forgetting it shows another branch's rows after a
 * branch switch.
 */
export const qk = {
  session: () => ["session"] as const,
  permissions: () => ["permissions"] as const,
  branches: {
    all: () => ["branches"] as const,
    list: (p: object = {}) => ["branches", "list", p] as const,
    detail: (id: number) => ["branches", "detail", id] as const,
  },
  roles: {
    all: () => ["roles"] as const,
    list: (p: object = {}) => ["roles", "list", p] as const,
  },
  users: {
    all: () => ["users"] as const,
    list: (p: object = {}) => ["users", "list", p] as const,
    detail: (id: number) => ["users", "detail", id] as const,
  },
  members: {
    all: () => ["members"] as const,
    list: (p: object = {}) => ["members", "list", p] as const,
    detail: (id: number) => ["members", "detail", id] as const,
    lookup: (phone: string) => ["members", "lookup", phone] as const,
  },
  imports: {
    all: () => ["imports"] as const,
    list: (p: object = {}) => ["imports", "list", p] as const,
    detail: (id: string) => ["imports", "detail", id] as const,
    preview: (id: string) => ["imports", "preview", id] as const,
    rows: (id: string, p: object = {}) => ["imports", "rows", id, p] as const,
  },
  deviceTokens: {
    all: () => ["device-tokens"] as const,
    list: (p: object = {}) => ["device-tokens", "list", p] as const,
  },
} as const;
